import getStudentsScoring from "./getStudentsScoring"

export default function fetchStudentsScoring(
  students,
  items,
  assessmentSets,
  assessmentId,
  year,
  compareAssessmentId,
  compareYear
) {
  let studentScoring = {}
  let studentScoringCompare = {}

  studentScoring = getStudentsScoring(
    students,
    items,
    assessmentSets,
    assessmentId,
    year
  )

  if (compareAssessmentId && compareYear) {
    studentScoringCompare = getStudentsScoring(
      students,
      items,
      assessmentSets,
      compareAssessmentId,
      compareYear
    )
  }

  return Promise.all([studentScoring, studentScoringCompare])
}
